'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { useHideDialog } from '../../../dialog/ducks';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
const editTypePropType = PropTypes.oneOf(['remove-default', 'set-default']);
export const SetDefaultDashboardModal = ({
  isAlreadyDefault,
  editTypeKey,
  onConfirm: _onConfirm = noop,
  appUsageTracker
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const hide = useHideDialog();
  const keyPath = `reporting-action-components.dashboards.editDefaultDashboard.${editTypeKey}`;
  const trackConfirmClick = () => {
    if (!usageTracker) {
      return;
    }
    const eventToTrack = isAlreadyDefault ? EVENTS.setDefaultDashboardNew : EVENTS.removeDefaultDashboardNew;
    usageTracker.track(eventToTrack);
  };
  const onConfirm = () => {
    _onConfirm(isAlreadyDefault);
    trackConfirmClick();
    hide();
  };
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${keyPath}.confirm`
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${keyPath}.cancel`
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${keyPath}.header`
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${keyPath}.message`
    }),
    onConfirm: onConfirm,
    onReject: hide
  });
};
SetDefaultDashboardModal.propTypes = {
  isAlreadyDefault: PropTypes.bool.isRequired,
  editTypeKey: editTypePropType,
  onConfirm: PropTypes.func.isRequired,
  appUsageTracker: PropTypes.object.isRequired
};
export default SetDefaultDashboardModal;